import { render, staticRenderFns } from "./Uptime.vue?vue&type=template&id=7ef141d0&scoped=true&"
import script from "./Uptime.vue?vue&type=script&lang=js&"
export * from "./Uptime.vue?vue&type=script&lang=js&"
import style0 from "./Uptime.vue?vue&type=style&index=0&id=7ef141d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef141d0",
  null
  
)

export default component.exports